import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TipoOperacion } from 'src/app/home/_models/tipo-operacion';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SellosComponent } from 'src/app/factoring/shared/utils/sellos/sellos.component';
import { RouterModule } from '@angular/router';
import { CifrasWebSego } from 'src/app/home/_models/cifras-web-sego';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CifrasWebSegoService } from 'src/app/home/_services/cifras-web-sego.service';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-tipos-operaciones',
  standalone: true,
  imports: [SharedModule, SellosComponent, RouterModule, BtnLinkComponent],
  templateUrl: './tipos-operaciones.component.html',
  styleUrls: ['./tipos-operaciones.component.scss']
})
export class TiposOperacionesComponent implements OnInit
{
  isPlatformFactoring: boolean;
  isLoading: boolean = false;
  cifrasWeb: CifrasWebSego;
  isApiCifrasError: boolean = false;
  operacionesData: TipoOperacion[];
  domainUrl: string;
  activeOperacionNum: number = 0;
  isOpenOperacion: boolean = false;
  isMobile: boolean = false;
  textosDesplegable: string[] = [];

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private _cifrasWebService: CifrasWebSegoService,
    private _platformService: PlatformService
  ) { }

  ngOnInit(): void
  {
    this.isPlatformFactoring = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment] == 'FACTORING' ? true : false;
    this.domainUrl = this._platformService.getSubdominioUrl('factoring');
    this.getCifrasWeb();
    this.checkIfMobile();
  }

  private checkIfMobile(): void
  {
    if (isPlatformBrowser(this._platformId))
    {
      window.innerWidth < 576 ? this.isMobile = true : this.isMobile = false;
    }
  }

  private getCifrasWeb(): void
  {
    this.isLoading = true;
    this._cifrasWebService.getCifrasSegoWeb().subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.cifrasWeb = r;
        !this.cifrasWeb && (this.isApiCifrasError = true);
      },
      complete: () =>
      {
        this.getFichaOperacionesData();
      },
      error: (e) =>
      {
        this.isLoading = false;
        this.isApiCifrasError = true;
      }
    });
  }

  private getFichaOperacionesData(): void
  {
    this.operacionesData = [

      {
        id: 1,
        titulo: 'Con Seguro',
        tipoPerfil: 'Perfil Conservador',
        rentaAnualizada: `${this.cifrasWeb.rentabilidadAnualAseguradas} Rent. Anualizada`,
        imgSource: 'assets/images/factoring/con-seguro.svg',
        tipoOperacionCodigo: 'con-seguro'
      },
      {
        id: 2,
        titulo: 'Sin Seguro',
        tipoPerfil: 'Perfil Moderado',
        rentaAnualizada: `${this.cifrasWeb.rentabilidadAnualNoAseguradas} Rent. Anualizada`,
        imgSource: 'assets/images/factoring/sin-seguro.svg',
        tipoOperacionCodigo: 'sin-seguro'
      },
      {
        id: 3,
        titulo: 'Admón. Pública',
        tipoPerfil: 'Perfil Equilibrado',
        rentaAnualizada: `${this.cifrasWeb.rentabilidadAnualAdminPublica} Rent. Anualizada`,
        imgSource: 'assets/images/factoring/admin-publica.svg',
        tipoOperacionCodigo: 'admin-publica'
      }
    ];
  }

  setOperacion(operacionId: number)
  {
    if (this.activeOperacionNum === operacionId)
    {
      // Si se hace click en el mismo panel, se cierra directamente
      this.isOpenOperacion = !this.isOpenOperacion;
    } else
    {
      if (this.isOpenOperacion)
      {
        this.isOpenOperacion = false;
        setTimeout(() =>
        {
          this.openOperacion(operacionId);
        }, 200);
      } else
      {
        // Si el panel está cerrado, abre directamente
        this.openOperacion(operacionId);
      }
    }

    // Actualiza el número de operación seleccionada
    this.activeOperacionNum = this.isOpenOperacion ? operacionId : 0;
  }

  openOperacion(operacionId: number)
  {
    this.activeOperacionNum = operacionId;
    this.isOpenOperacion = true;
    this.getTextosDesplegable();
  }

  private getTextosDesplegable(): void
  {
    switch (this.activeOperacionNum)
    {
      case 1:
        this.textosDesplegable = [
          'Entidad aseguradora que cubre el principal invertido.',
          'Oportunidades con un plazo medio inferior a 90 días.',
          'Operaciones con empresas de alto prestigio.',
          'La fecha de vencimiento es la acordada para el pago, pero puede retrasarse por días festivos, pagos con pagaré (retraso de unos 8 días) o por demora del deudor.'
        ];
        break;
      case 2:
        this.textosDesplegable = [
          'Operaciones con empresas de alto prestigio.',
          'Rentabilidad atractiva.',
          'Oportunidades con un plazo medio superior a 100 días.',
          'La fecha de vencimiento es la acordada para el pago, pero puede retrasarse por días festivos, pagos con pagaré (retraso de unos 8 días) o por demora del deudor.'
        ];
        break;
      case 3:
        this.textosDesplegable = [
          'Oportunidades con más de 50 organismos públicos diferentes.',
          'Operaciones a 90 días.',
          'En ocasiones, la fecha de vencimiento puede ser muy incierta. Algunos organismos acostumbran a pagar con semanas e incluso meses de retraso. En estos casos, se abonarán siempre los intereses de demora para el periodo correspondiente al retraso.'
        ];
        break;
      default:
        break;
    }
  }

}
